import { Switch } from 'antd';
import '../../App.css'
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllOpenBets, fetchOpenBetById } from '../../redux/slice/openBets/openBetsSlice'
import { useParams } from 'react-router-dom';
function RightSidebar() {
    const dispatch = useDispatch();
    const { currentEventId, eventData, loading, error } = useSelector((state) => state.events);
    const { openBets, loading: openBetsLoading, error: openBetsError } = useSelector((state) => state.openBets);
    const { isAuthenticated } = useSelector((state) => state.authSlice);
    const [showTv, setShowTv] = useState(false);
    const handleSwitchChange = (checked) => {
        setShowTv(checked);
    };
    // useEffect(() => {
    //     if (window.location.pathname.includes('event') && currentEventId) {
    //         console.log('fetchOpenBetById', currentEventId)
    //         dispatch(fetchOpenBetById(currentEventId));
    //     }
    //     else {
    //         console.log('fetchAllOpenBets')
    //         dispatch(fetchAllOpenBets());
    //     }
    // }, [isAuthenticated, dispatch, currentEventId, window.location.pathname])
    return (
        <div className='overflow-x-hidden overflow-y-auto bg-[#ffffff] h-auto relative'>
            <div>
                <div className='mb-[.25rem]  text-[#ffffff] '>
                    <p className='bg-[#18adc5] text-[#fff] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] flex items-center justify-between capitalize'>
                        Live TV
                        <Switch className='tv-switch' size="small" value={showTv} onChange={handleSwitchChange} />
                    </p>
                </div>
                {
                    showTv && (
                        <div className='tviframe mb-[.25rem]'>
                            <iframe
                                className='h-[207px]'
                                title="iframe mobile"
                                id="tvframe"
                                marginwidth="0" marginheight="0" frameborder="0" width="100%" height="100%" scrolling="no" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"
                                onLoad={() => setShowTv(true)} src={eventData?.tv_link}
                            >
                            </iframe>
                        </div>
                    )
                }
                <div className='bg-[#5ecbdd] bg-[linear-gradient(#5ecbdd,_#146578)] text-[#ffffff] text-[12px] h-[23px] px-[4px] py-0'>
                    <div className="w-full float-left">
                        <span className="text-[#ffffff]  inline text-[14px] p-[2px]">Matched Bet</span>
                    </div>
                </div>
                <div className="bg-white block w-full">
                    <table className="w-full whitespace-nowrap !mb-6 text-[#212529]">
                        <thead className=''>
                            <tr className="!bg-[#028dad] !text-[#ffffff]">
                                <th className='px-[3px] py-px border-[#fff] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>Matched Bet</th>
                                <th className='px-[3px] py-px border-[#fff] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>Odds</th>
                                <th className='px-[3px] py-px border-[#fff] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>Stake</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                openBets?.length > 0 ?
                                    openBets?.map((item, index) => (
                                        <tr key={index} className={item?.is_back ? "bg-[#72bbef]" : "bg-[#faa9ba]"}>
                                            <th className='px-[3px] py-px border-[#dee2e6] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>{item?.runner_name}</th>
                                            <th className='px-[3px] py-px border-[#dee2e6] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>{item?.price_val}</th>
                                            <th className='px-[3px] py-px border-[#dee2e6] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>{item?.stake}</th>
                                        </tr>
                                    ))
                                    :
                                    <tr>
                                        <td className="px-[3px] py-px border-[1px] border-[solid] border-[#dee2e6]  !text-[#c7313f] !text-center" colSpan="3">No bets found...</td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}


export default RightSidebar;
